import { Link } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { Button } from '#app/ui/components/buttons/button.tsx'
import { Pill } from '#app/ui/components/custom/pill'
import { Container } from '#app/ui/components/layout/container'
import { H1 } from '#app/ui/components/typography/h1'
import { Lead } from '#app/ui/components/typography/lead'
import { P } from '#app/ui/components/typography/p'
import { Strong } from '#app/ui/components/typography/strong'

export const Hero = () => {
	const { t } = useTranslation('home')

	return (
		<div className="relative overflow-hidden">
			<div
				aria-hidden
				className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[38rem] bg-[radial-gradient(60rem_28rem_at_50%_-8rem,theme(colors.surface),transparent)]"
			/>
			<Container>
				<div className="mx-auto flex max-w-3xl flex-col items-center pb-fluid-17 pt-fluid-15 text-center">
					<Pill>{t('hero.pill')}</Pill>
					<H1 className="mt-fluid-6 text-balance text-fluid-5xl normal-case">
						{t('hero.title')}
					</H1>
					<Lead className="mt-fluid-5 max-w-2xl text-muted-600">
						{t('hero.lead')}
					</Lead>

					<div className="mt-fluid-12 max-w-2xl text-left">
						<P className="text-muted-600">{t('hero.p1')}</P>
						<P className="text-muted-600">
							{t('hero.p2Before')}{' '}
							<Strong className="text-foreground">{t('hero.p2Strong')}</Strong>{' '}
							{t('hero.p2After')}
						</P>
						<P className="text-muted-600">{t('hero.p3')}</P>
						<P className="text-muted-600">{t('hero.p4')}</P>
					</div>

					<div className="mt-fluid-12 flex flex-wrap items-center justify-center gap-6">
						<Button asChild size="lg">
							<Link to="/call">{t('hero.cta')}</Link>
						</Button>
						<Link
							to="#what-i-build"
							className="font-medium text-muted-700 hover:text-foreground"
						>
							{t('hero.secondary')}
						</Link>
					</div>
					<p className="mt-fluid-6 text-center text-sm text-muted-500">
						{t('hero.noteLine1')}
						<span className="block">{t('hero.noteLine2')}</span>
					</p>
				</div>
			</Container>
		</div>
	)
}
